<template>
  <div>
    <div class="rigging">
      <kinesis-container class="skull-container">
        <Skull class="skull" />
      </kinesis-container>
    </div>
    <div class="credits">
      <a
        href="https://www.freepik.com/free-vector/hand-drawn-dia-de-muertos-background_5733483.htm"
        target="_blank"
        >Mariachi</a
      >
    </div>
  </div>
</template>

<script>
import { KinesisContainer } from "vue-kinesis";

import Skull from "./Skull.vue";
export default {
  components: {
    Skull,
    KinesisContainer
  }
};
</script>

<style lang="scss" scoped>
.skull {
  height: 300px;
}

.rigging {
  display: flex;
  justify-content: center;
}

.skull-container {
  padding: 20px 30px;
  background-color: #e35353;
  border-radius: 10px;
}

.credits {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.credits a {
  color: white;
  text-decoration: none;
  font-size: 12px;
}

.credits a:hover {
  text-decoration: underline;
}
</style>
